import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useThemeStore } from 'academy-common-lib/utils/Styling';
import { ThemedToggle } from '../../../components/ThemedComponents';
import usageTracker from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicPageThemeToggle = () => {
  const {
    theme,
    setTheme
  } = useThemeStore();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    inlineSize: "inherit",
    children: [/*#__PURE__*/_jsx(ThemedToggle, {
      checked: theme === 'highContrast',
      id: "high-contrast-toggle",
      marginInlineEnd: "200",
      onChange: e => {
        if (e.target.checked) {
          setTheme('highContrast');
        } else {
          setTheme('light');
        }
        usageTracker.track('navInteraction', {
          action: 'theme-toggled',
          value: e.target.checked ? 'highContrast' : 'light'
        });
      },
      size: "small"
    }), /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "high-contrast-toggle",
      children: /*#__PURE__*/_jsx(Paragraph, {
        margin: "0",
        padding: "0",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.publicNav.highContrast"
        })
      })
    })]
  });
};
export default PublicPageThemeToggle;